import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function generateExcel(data, fields, worksheetName, fileName) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(worksheetName);
  const columnKeys = Object.keys(fields);

  worksheet.columns = columnKeys.map((key) => ({
    header: key,
    key: key,
    width: fields[key]?.width ?? 20
  }));

  // Make the first row bold
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
  });

  // Prepare rows
  const rows = data.map(item => {
    const row = {};
    columnKeys.forEach(key => {
      const fieldConfig = fields[key];
      let value;

      if (typeof fieldConfig === 'string') {
        value = item[fieldConfig]; // return the item as it is, no transformation
      } else {
        const field = fieldConfig.field;
        const callback = fieldConfig.callback;

        value = callback ? callback(item[field]) : item[field];
      }
      row[key] = value;
    });
    return row;
  });

  worksheet.addRows(rows);

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
}